<head>
    <!-- Google Tag Manager -->

    <script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>

    <!-- End Google Tag Manager -->
</head>
<!-- Google Tag Manager (noscript) -->

<noscript>
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0"
        style="display:none;visibility:hidden"></iframe>
</noscript>

<!-- End Google Tag Manager (noscript) -->
<div class="template" *ngIf="!mobile">
    <br />
    <h1>New to IBKR - What you need to know:</h1>
    <br />
    <div class="box">
        <div class="col">
            <div class="row">
                <div class="col">
                    <button data-bs-toggle="modal" data-bs-target="#contentAcad1"><img class="card-img-top"
                            src="assets/img/academy1.png" alt="Card image cap"></button>
                </div>
                <div class="col">
                    <div class="card-body">
                        <h2 class="card-title">Introducing - IBKR</h2>
                        <p class="card-text"><small class="text-muted">by IBKR<br />30 seconds</small></p>
                        <p class="card-text pText">In a nutshell, here’s what IBKR offers; lowest trading costs across stocks, options, forex… from a single integrated account with all the analysis needed.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="row">
                <div class="col">
                    <button data-bs-toggle="modal" data-bs-target="#contentAcad2"><img class="card-img-top"
                            src="assets/img/academy2.png" alt="Card image cap"></button>
                </div>
                <div class="col">
                    <div class="card-body">
                        <h2 class="card-title">IBKR Client Portal API</h2>
                        <p class="card-text"><small class="text-muted">by IBKR<br />9 minutes 5 seconds</small></p>
                        <p class="card-text pText">This enables automation of market data requests, live trading information… through the IBKR training videos available through its Traders’Academy.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="box">
        <div class="col">
            <div class="row">
                <div class="col">
                    <button data-bs-toggle="modal" data-bs-target="#contentAcad3"><img class="card-img-top"
                            src="assets/img/academy3.png" alt="Card image cap"></button>
                </div>
                <div class="col">
                    <div class="card-body">
                        <h2 class="card-title">IBKR Fundamental Explorer</h2>
                        <p class="card-text"><small class="text-muted">by IBKR<br />8 minutes 38 seconds</small></p>
                        <p class="card-text pText">A research tool drawing together financial information, keys facts about the company, historical date and analysts forecasts within a user-friendly interface.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">

            <div class="row">
                <div class="col">
                    <button data-bs-toggle="modal" data-bs-target="#contentAcad4"><img class="card-img-top"
                            src="assets/img/academy4.png" alt="Card image cap"></button>
                </div>
                <div class="col">
                    <div class="card-body">
                        <h2 class="card-title">IBKR Platforms Overview</h2>
                        <p class="card-text"><small class="text-muted">by IBKR<br />11 minutes 30 seconds</small></p>
                        <p class="card-text pText">The Trader Workstation provides access to an array of exchange-traded asset classes with a seamless transition across mobile operating in real time.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="box">
        <div class="col">
            <div class="row">
                <div class="col">
                    <button data-bs-toggle="modal" data-bs-target="#contentAcad5"><img class="card-img-top"
                            src="assets/img/academy5.png" alt="Card image cap"></button>
                </div>
                <div class="col">
                    <div class="card-body width">
                        <h2 class="card-title">Introduction to Order Types</h2>
                        <p class="card-text"><small class="text-muted">by IBKR<br />2 minutes 41 seconds</small></p>
                        <p class="card-text pText">An overview of order types from the typical, “Market”, “Limit” and “Stop”… on how and when to use them as well as why to do so including algorithmic types.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col" style="margin-top: 6rem">
            <a href="https://drive.google.com/drive/folders/18k1sMyVXm9lWobDHRoHcgMxGWhO7SDyo" target="_blank"
                rel="noopener noreferrer">
                <div class="container">
                    <div class="row align-items-start justify-content-center no-gutters">
                        <div class="col-md-auto">
                            <span class="hero__play js-play" target="_blank">
                                <img src="assets/img/svg/ico-play.svg" alt="Play button">
                            </span>
                        </div>
                        <div class="col-md-auto" style="font-size: large">
                            Video Academy - View More
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>

    <!-- <div style="text-align: center"><iframe src="https://widget.tagembed.com/65895?view" style=" width:760px;height:1260px;overflow: auto;" frameborder="0" allowtransparency="true"></iframe></div> -->

</div>

<div class="template" *ngIf="mobile">
    <h1>New to IBKR - What you need to know:</h1>
    <div class='carousel-wrapper'>
        <ul class='carousel x mandatory'>
            <li class="bg-white">
                <div class="row cardItem">
                    <div class="col">
                        <div class="card">
                            <button data-bs-toggle="modal" data-bs-target="#contentAcad1"><img class="card-img-top"
                                    src="assets/img/academy1.png" alt="Card image cap"></button>
                            <div class="card-body">
                                <h2 class="card-title">Introducing - IBKR</h2>
                                <p class="card-text"><small class="text-muted">by IBKR<br />30 seconds</small></p>
                                <p class="card-text pText">In a nutshell, here’s what IBKR offers; lowest trading costs across stocks, options, forex… from a single integrated account with all the analysis needed.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li class="bg-white">
                <div class="row cardItem">
                    <div class="col">
                        <div class="card">
                            <button data-bs-toggle="modal" data-bs-target="#contentAcad2"><img class="card-img-top"
                                    src="assets/img/academy2.png" alt="Card image cap"></button>
                            <div class="card-body">
                                <h2 class="card-title">IBKR Client Portal API</h2>
                                <p class="card-text"><small class="text-muted">by IBKR<br />9 minutes 5 seconds</small>
                                </p>
                                <p class="card-text pText">This enables automation of market data requests, live trading information… through the IBKR training videos available through its Traders’Academy.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li class="bg-white">
                <div class="row cardItem">
                    <div class="col">
                        <div class="card">
                            <button data-bs-toggle="modal" data-bs-target="#contentAcad3"><img class="card-img-top"
                                    src="assets/img/academy3.png" alt="Card image cap"></button>
                            <div class="card-body">
                                <h2 class="card-title">IBKR Fundamental Explorer</h2>
                                <p class="card-text"><small class="text-muted">by IBKR<br />8 minutes 38 seconds</small>
                                </p>
                                <p class="card-text pText">A research tool drawing together financial information, keys facts about the company, historical date and analysts forecasts within a user-friendly interface.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li class="bg-white">
                <div class="row cardItem">
                    <div class="col">
                        <div class="card">
                            <button data-bs-toggle="modal" data-bs-target="#contentAcad4"><img class="card-img-top"
                                    src="assets/img/academy4.png" alt="Card image cap"></button>
                            <div class="card-body">
                                <h2 class="card-title">IBKR Platforms Overview</h2>
                                <p class="card-text"><small class="text-muted">by IBKR<br />11 minutes 30
                                        seconds</small></p>
                                <p class="card-text pText">The Trader Workstation provides access to an array of exchange-traded asset classes with a seamless transition across mobile operating in real time.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li class="bg-white">
                <div class="row cardItem">
                    <div class="col">
                        <div class="card">
                            <button data-bs-toggle="modal" data-bs-target="#contentAcad5"><img class="card-img-top"
                                    src="assets/img/academy5.png" alt="Card image cap"></button>
                            <div class="card-body">
                                <h2 class="card-title">Introduction to Order Types</h2>
                                <p class="card-text"><small class="text-muted">by IBKR<br />2 minutes 41 seconds</small>
                                </p>
                                <p class="card-text pText">An overview of order types from the typical, “Market”, “Limit” and “Stop”… on how and when to use them as well as why to do so including algorithmic types.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </li>

        </ul>

    </div>
</div>

<ng-template #contentAcad1 let-modal>
    <div class="modal-header">
        <h1 class="modal-title" id="modal-basic-title">Introducing - IBKR</h1>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body modalSize" style="font-size:large;">
        <iframe src="https://theapi.cosmic-algorithm.ie/Introducing-IBKR.mp4" width="640" height="480"
            allow="autoplay"></iframe>
    </div>
</ng-template>

<ng-template #contentAcad2 let-modal>
    <div class="modal-header">
        <h1 class="modal-title" id="modal-basic-title">IBKR's Client Portal API
        </h1>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body modalSize" style="font-size:large">
        <iframe src="https://theapi.cosmic-algorithm.ie/IBKR-Client-Portal-API.mp4" width="640" height="480"
            allow="autoplay"></iframe>
    </div>
</ng-template>

<ng-template #contentAcad3 let-modal>
    <div class="modal-header">
        <h1 class="modal-title" id="modal-basic-title">IBKR Fundamental Explorer</h1>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body modalSize" style="font-size:large">
        <iframe src="https://theapi.cosmic-algorithm.ie/IBKR-Fundamental-Explorer.mp4" width="640" height="480"
            allow="autoplay"></iframe>
    </div>
</ng-template>

<ng-template #contentAcad4 let-modal>
    <div class="modal-header">
        <h1 class="modal-title" id="modal-basic-title">IBKR Platforms Overview</h1>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body modalSize" style="font-size:large">
        <iframe src="https://theapi.cosmic-algorithm.ie/IBKR-platforms-overview.mp4" width="640" height="480"
            allow="autoplay"></iframe>
    </div>
</ng-template>

<ng-template #contentAcad5 let-modal>
    <div class="modal-header">
        <h1 class="modal-title" id="modal-basic-title">Introduction to Order Types</h1>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body modalSize" style="font-size:large">
        <iframe src="https://theapi.cosmic-algorithm.ie/Introduction-to-Order-Types.mp4" width="640" height="480"
            allow="autoplay"></iframe>
    </div>
</ng-template>

<div class="modal" id="contentAcad1">
    <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">


            <div class="modal-body">
                <video height="95%" width="100%" controls #gettingStarted>
                    <source src="https://theapi.cosmic-algorithm.ie/Introducing-IBKR.mp4" type="video/mp4">
                </video>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer" style="    margin: auto;
				margin-bottom: 1%;
				margin-top: -1%;">
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                    (click)="close(gettingStarted)">Close</button>
            </div>

        </div>
    </div>
</div>

<div class="modal" id="contentAcad2">
    <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">


            <div class="modal-body">
                <video height="95%" width="100%" controls #openingAccount>
                    <source src="https://theapi.cosmic-algorithm.ie/IBKR-Client-Portal-API.mp4" type="video/mp4">
                </video>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer" style="    margin: auto;
				margin-bottom: 1%;
				margin-top: -1%;">
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                    (click)="close(openingAccount)">Close</button>
            </div>

        </div>
    </div>
</div>

<div class="modal" id="contentAcad3">
    <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">


            <div class="modal-body">
                <video height="95%" width="100%" controls #copyTrading>
                    <source src="https://theapi.cosmic-algorithm.ie/IBKR-Fundamental-Explorer.mp4" type="video/mp4">
                </video>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer" style="    margin: auto;
				margin-bottom: 1%;
				margin-top: -1%;">
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                    (click)="close(copyTrading)">Close</button>
            </div>

        </div>
    </div>
</div>

<div class="modal" id="contentAcad4">
    <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">


            <div class="modal-body">
                <video height="95%" width="100%" controls #verification>
                    <source src="https://theapi.cosmic-algorithm.ie/IBKR-platforms-overview.mp4" type="video/mp4">
                </video>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer" style="    margin: auto;
				margin-bottom: 1%;
				margin-top: -1%;">
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                    (click)="close(verification)">Close</button>
            </div>

        </div>
    </div>
</div>

<div class="modal" id="contentAcad5">
    <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">


            <div class="modal-body">
                <video height="95%" width="100%" controls #stopLoss>
                    <source src="https://theapi.cosmic-algorithm.ie/Introduction-to-Order-Types.mp4" type="video/mp4">
                </video>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer" style="    margin: auto;
				margin-bottom: 1%;
				margin-top: -1%;">
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                    (click)="close(stopLoss)">Close</button>
            </div>

        </div>
    </div>
</div>